import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=4ce54bd0&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=4ce54bd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce54bd0",
  null
  
)

export default component.exports